import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { PartialRange } from 'features/valueObjects/Range'
import { GarageFilterCardDumb } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/GarageFilterCard/GarageFilterCard.dumb'
import { GarageFilterCardDumbProps as Props } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/GarageFilterCard/GarageFilterCard.dumb.props'
import { shallow } from 'zustand/shallow'

export const GarageFilterCard = () => {
  const isReady = useCMAStore(state =>
    checkStateHasReportData(state.local.report),
  )

  const {
    subjectValue,
    filterValue,
  } = useCMAStore(state => {
    if (!checkStateHasReportData(state.local.report)) {
      return {
        subjectValue: null,
        filterValue: null,
      }
    }

    return {
      subjectValue: state.local.report.data.salesListInfo.subject?.garageSpacesCount ?? null,
      filterValue: state.local.report.data.filters.garageSpacesCount,
    }
  }, shallow)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = filter => {
    void filterComps({
      garageSpacesCount: filter,
    })
  }

  if (!isReady) return null

  return (
    <GarageFilterCardDumb
      value={filterValue || {
        range: PartialRange.EMPTY,
        shouldMatchSubjectProperty: false,
        shouldExcludeAll: false,
        type: null,
      }}
      onChange={handleOnValueChange}
      subjectValue={{
        garageSpacesCount: subjectValue,
        shouldExcludeAll: false,
        type: null,
      }}
    />
  )
}
